import React, { createContext, useContext, useState, useEffect } from 'react';

const PortfolioContext = createContext();

export const usePortfolio = () => useContext(PortfolioContext);

export const PortfolioProvider = ({ children }) => {
    const [portfolioData, setPortfolioData] = useState({
        selectedAssets: [],
        assetDetails: [],
        correlationMatrix: [],
        covarianceMatrix: [], 
        returnsArray: [],
        userPreferences: {},
        optimizationResults: {},
        optimizationMethod: "Default",
        wealth: 1000000,
    });

    const calculateReturnsArray = (selectedAssets) => {
        return selectedAssets.map(asset => asset.return);
    };

    const calculateCovarianceMatrix = (assetDetails) => {
        if (!assetDetails || !Array.isArray(assetDetails)) {
            console.error('Asset details are missing or not an array.');
            return [];
        }
    
        // Log each step for easier debugging
    
        return assetDetails.map((asset, i) => {
            if (typeof asset.volatility !== 'number') {
                console.error(`Volatility missing or incorrect type for asset ${asset.name}:`, asset.volatility);
                return Array(assetDetails.length).fill(0); // Return a row of zeros for this asset
            }
    
            return assetDetails.map((otherAsset, j) => {
                if (typeof otherAsset.volatility !== 'number') {
                    console.error(`Volatility missing or incorrect type for other asset ${otherAsset.name}:`, otherAsset.volatility);
                    return 0; // Return zero for this specific entry
                }
    
                const correlation = asset.correlations && asset.correlations[otherAsset.name];
                if (typeof correlation !== 'number') {
                    console.error(`Correlation coefficient missing or incorrect type between ${asset.name} and ${otherAsset.name}:`, correlation);
                    return 0; // Return zero for this specific entry
                }
    
                return asset.volatility * otherAsset.volatility * correlation;
            });
        });
    };
    // Function to update the portfolio's wealth
    const updateWealth = (newWealth) => {
        // Perform validation if necessary, e.g., ensuring newWealth is positive
        if (newWealth >= 0) {
            setPortfolioData(prevState => ({
                ...prevState,
                wealth: newWealth,
            }));
        } else {
            console.error("Wealth cannot be negative.");
        }
    };
    
    // Function to update optimization results
    const updateOptimizationResults = (optimizedWeights, Newwealth) => {
        setPortfolioData(currentData => ({
            ...currentData,
            optimizationResults: {
                ...currentData.optimizationResults,
                ...optimizedWeights, 
            },
            wealth: Newwealth,
        }));
    };
    
    // Function to update optimization method name
    const updateOptimizationMethod = (methodName) => {
        setPortfolioData(currentData => ({
            ...currentData,
            optimizationMethod: methodName // Update the optimization method name
        }));
    };


    // Recalculate returnsArray and covarianc matrix whenever selectedAssets changes
    useEffect(() => {
        console.log('Updating returnsArray', portfolioData.selectedAssets);
        const updatedReturnsArray = calculateReturnsArray(portfolioData.selectedAssets);
        console.log("New returnsArray:", updatedReturnsArray);
        const updatedCovarianceMatrix = calculateCovarianceMatrix(portfolioData.selectedAssets);
        console.log("New CovarianceMatrix:", updatedCovarianceMatrix);
        setPortfolioData(prevState => ({
            ...prevState,
            returnsArray: updatedReturnsArray,
            covarianceMatrix: updatedCovarianceMatrix,
        }));

    }, [portfolioData.selectedAssets]);
    
    return (
        <PortfolioContext.Provider value={{ portfolioData, setPortfolioData, updateOptimizationResults, updateOptimizationMethod, updateWealth }}>
            {children}
        </PortfolioContext.Provider>
    );
};

